import * as types from "~/store/faq/faqType";

export const getAllFAQ = () => {
  return {
    type: types.GET_ALL_FAQ
  };
};

export const updateShowedFAQByGroup = groupName => {
  return {
    type: types.UPDATE_SHOWED_FAQ_BY_GROUP,
    payload: groupName
  };
};

export const updateShowedFAQBySearch = searchValue => {
  return {
    type: types.UPDATE_SHOWED_FAQ_BY_SEARCH,
    payload: searchValue
  };
};
